module.exports = __webpack_public_path__ + "media/media/about/we_provide_training-971559677804ce25173dd4203c1c2f82.png";